module.exports = __webpack_public_path__ + "img/concert_cn_hover.8f5989f2.png";